function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { isEmpty } from 'lodash-es';
import * as superagent from 'superagent';
import { generateGuid } from '@shared/utils/appUtils';
import { Constants } from '@shared/utils/constants';
import { HttpError } from '@server/errors';
import { getAppConfig } from '@shared/services/init/appConfig';
import { shouldRefreshToken, logOutRequestStart, logOutRequestEnd, logOutRequestError, scrubHeaders } from '@shared/utils/httpClientUtil';
import { createSetAccessTokenAction } from '@shared/actions/actions';
import { mergeAccessToken } from '@shared/utils/accessToken';
import { fetchAccessTokens } from '@shared/msal/tokens';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const queryString = require('query-string');
(function(HttpModule) {
    let accessToken = null;
    let store = null;
    function updateAccessToken(newAccessToken) {
        if (!isEmpty(newAccessToken)) {
            accessToken = _object_spread({}, newAccessToken);
        }
    }
    HttpModule.updateAccessToken = updateAccessToken;
    function getAccessToken() {
        return accessToken;
    }
    HttpModule.getAccessToken = getAccessToken;
    function updateStore(outerStore) {
        store = outerStore;
    }
    HttpModule.updateStore = updateStore;
    function getStore() {
        return store;
    }
    HttpModule.getStore = getStore;
})(HttpModule || (HttpModule = {}));
// bitmasks for the authentication types
export var AuthenticationTypes = /*#__PURE__*/ function(AuthenticationTypes) {
    AuthenticationTypes[AuthenticationTypes["Unauthenticated"] = 0] = "Unauthenticated";
    AuthenticationTypes[AuthenticationTypes["Spza"] = 1] = "Spza";
    AuthenticationTypes[AuthenticationTypes["Graph"] = 4] = "Graph";
    AuthenticationTypes[AuthenticationTypes["Arm"] = 16] = "Arm";
    AuthenticationTypes[AuthenticationTypes["JarvisCM"] = 64] = "JarvisCM";
    AuthenticationTypes[AuthenticationTypes["Pifd"] = 128] = "Pifd";
    AuthenticationTypes[AuthenticationTypes["CommerceApi"] = 256] = "CommerceApi";
    AuthenticationTypes[AuthenticationTypes["MarketplaceLeads"] = 512] = "MarketplaceLeads";
    AuthenticationTypes[AuthenticationTypes["Agreement"] = 1024] = "Agreement";
    return AuthenticationTypes;
}({});
function isResponseWithHeader(response) {
    return !!(response === null || response === void 0 ? void 0 : response._header);
}
function isResponseWithRequest(response) {
    return !!(response === null || response === void 0 ? void 0 : response.request);
}
function isResponseWithReq(response) {
    return !!(response === null || response === void 0 ? void 0 : response.req);
}
export function scrubResponseHeaders(response) {
    if (response === null || response === void 0 ? void 0 : response.headers) {
        response.headers = scrubHeaders(response.headers);
    }
    if (response === null || response === void 0 ? void 0 : response.header) {
        response.header = scrubHeaders(response.header);
    }
    if (isResponseWithHeader(response)) {
        response._header = scrubHeaders(response._header);
    }
}
function scrubErrorHeaders(error) {
    scrubResponseHeaders(error === null || error === void 0 ? void 0 : error.response);
    if (isResponseWithRequest(error === null || error === void 0 ? void 0 : error.response)) {
        scrubResponseHeaders(error.response.request);
    }
    if (isResponseWithReq(error === null || error === void 0 ? void 0 : error.response)) {
        scrubResponseHeaders(error.response.req);
    }
    return error;
}
export class HttpWrapper {
    initQuery(queryParams) {
        for(const key in queryParams){
            if (Object.prototype.hasOwnProperty.call(queryParams, key)) {
                const value = queryParams[`${key}`];
                if (value !== null && value !== undefined) {
                    this.addQueryEntry(key, value);
                }
            }
        }
        return this;
    }
    addOption(option) {
        for(const entry in option){
            // eslint-disable-next-line no-prototype-builtins
            if (option.hasOwnProperty(entry)) {
                this.option[`${entry}`] = option[`${entry}`];
            }
        }
        return this.option;
    }
    copyOption(option) {
        option = option || this.option;
        const copy = {
            authenticationType: 0
        };
        for(const entry in option){
            // eslint-disable-next-line no-prototype-builtins
            if (option.hasOwnProperty(entry)) {
                copy[`${entry}`] = option[`${entry}`];
            }
        }
        return copy;
    }
    setQuery(query) {
        if (query) {
            this.query = query;
        }
        return this;
    }
    addQuery(query) {
        for(const entry in query){
            // eslint-disable-next-line no-prototype-builtins
            if (query.hasOwnProperty(entry)) {
                this.query[`${entry}`] = query[`${entry}`];
            }
        }
        return this;
    }
    addQueryEntry(entry, value) {
        if (!this.query) {
            this.setQuery({});
        }
        this.query[`${entry}`] = value;
        return this;
    }
    getQueryString(query) {
        query = query || this.query;
        if (query) {
            // It uses encodeURIComponent if 'strict' is set to false. Otherwise it strictly encodes URI components with strict-uri-encode.
            return queryString.stringify(query, {
                strict: false
            });
        } else {
            return '';
        }
    }
    setData(data) {
        this.data = data;
        return this;
    }
    setRetry(retry) {
        this.option.retry = retry;
        return this;
    }
    setHeader(entry, value) {
        this.header[`${entry}`] = value;
        return this;
    }
    setAuthHeader(token, authHeaderTitle = Constants.Headers.Authorization) {
        if (token) {
            this.header[`${authHeaderTitle}`] = token.startsWith('Bearer') ? token : 'Bearer ' + token;
        }
        return this;
    }
    addHeader(header) {
        for(const entry in header){
            // eslint-disable-next-line no-prototype-builtins
            if (header.hasOwnProperty(entry)) {
                this.header[`${entry}`] = header[`${entry}`];
            }
        }
        return this;
    }
    emptyQuery() {
        if (!this.query) {
            return true;
        }
        for(const entry in this.query){
            // eslint-disable-next-line no-prototype-builtins
            if (this.query.hasOwnProperty(entry)) {
                return false;
            }
        }
        return true;
    }
    request(retry) {
        return this.requestWithHeaders(retry).then((d)=>d.data);
    }
    requestWithHeaders(retry) {
        let url = this.endpoint;
        if (!this.emptyQuery()) {
            url += '?' + this.getQueryString(this.query);
        }
        let request = null;
        if (this.method === 'POST') {
            request = superagent.post(url);
        }
        if (this.method === 'PATCH') {
            request = superagent.patch(url);
        }
        if (this.method === 'PUT') {
            request = superagent.put(url);
        }
        if (this.method === 'GET') {
            request = superagent.get(url);
        }
        if (this.method === 'DELETE') {
            request = superagent.delete(url);
        }
        if (retry == null) {
            retry = this.option.retry;
        }
        if (retry > 0) {
            request.retry(retry);
        }
        const timeout = this.option.timeout;
        if (timeout && timeout > 0) {
            request.timeout(timeout);
        }
        if (this.option.setBuffer) {
            request.buffer();
        }
        if (this.option.responseType) {
            request.responseType(this.option.responseType);
        }
        if (this.option.type) {
            request.type(this.option.type);
        }
        if (getAppConfig().agent && this.endpoint.startsWith('https')) {
            request.agent(getAppConfig().agent);
        }
        if (this.option.allowOrigin) {
            this.addHeader({
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'POST, PUT, GET, OPTIONS, DELETE',
                'Access-Control-Allow-Headers': 'x-requested-with'
            });
        }
        if (this.option.requireCorrelationId && !this.header[Constants.Headers.CorrelationId]) {
            return Promise.reject(Error('CorrelationId not found in the header'));
        }
        // set headers
        for(const property in this.header){
            // eslint-disable-next-line no-prototype-builtins
            if (this.header.hasOwnProperty(property)) {
                request.set(property, this.header[`${property}`]);
            }
        }
        // POST & DELETE
        if (this.method === 'POST' || this.method === 'PATCH' || this.method === 'PUT' || this.method === 'DELETE') {
            if (this.option.contentType === 'application/json' && typeof this.data !== 'string' && this.option.stringifyPostData) {
                request.send(JSON.stringify(this.data));
            } else {
                request.send(this.data);
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        // refresh access token
        let shouldRefreshAccessToken = false;
        if (this.option.authenticationType > 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            const accessToken = HttpModule.getAccessToken();
            if (__CLIENT__ && accessToken) {
                if (this.option.authenticationType & 1) {
                    shouldRefreshAccessToken = shouldRefreshAccessToken || shouldRefreshToken(accessToken.spza);
                }
                if (this.option.authenticationType & 4) {
                    shouldRefreshAccessToken = shouldRefreshAccessToken || shouldRefreshToken(accessToken.graph);
                }
                if (this.option.authenticationType & 16) {
                    shouldRefreshAccessToken = shouldRefreshAccessToken || shouldRefreshToken(accessToken.arm);
                }
                if (this.option.authenticationType & 256) {
                    shouldRefreshAccessToken = shouldRefreshAccessToken || shouldRefreshToken(accessToken.commerce);
                }
                if (this.option.authenticationType & 64) {
                    shouldRefreshAccessToken = shouldRefreshAccessToken || shouldRefreshToken(accessToken.jarvis);
                }
                if (this.option.authenticationType & 128) {
                    shouldRefreshAccessToken = shouldRefreshAccessToken || shouldRefreshToken(accessToken.pifd);
                }
                if (this.option.authenticationType & 512) {
                    shouldRefreshAccessToken = shouldRefreshAccessToken || shouldRefreshToken(accessToken.marketplaceLeads);
                }
                if (this.option.authenticationType & 1024) {
                    shouldRefreshAccessToken = shouldRefreshAccessToken || shouldRefreshToken(accessToken.agreement);
                }
            }
        }
        const setAuthenticationHeaders = (authenticationType, accessToken, setBearerHeader = false)=>{
            if (accessToken) {
                if (authenticationType & 1 && accessToken.spza) {
                    if (setBearerHeader) {
                        request.set(Constants.Headers.Authorization, Constants.Headers.Bearer + accessToken.spza);
                    } else {
                        request.set(Constants.Headers.Authorization, accessToken.spza);
                    }
                }
                if (authenticationType & 4 && accessToken.graph) {
                    request.set(Constants.Headers.Authorization, Constants.Headers.Bearer + accessToken.graph);
                }
                if (authenticationType & 16 && accessToken.arm) {
                    request.set(Constants.Headers.Authorization, Constants.Headers.Bearer + accessToken.arm);
                }
                if (authenticationType & 256 && accessToken.commerce) {
                    request.set(Constants.Headers.Authorization, Constants.Headers.Bearer + accessToken.commerce);
                }
                if (authenticationType & 64 && accessToken.jarvis) {
                    request.set(Constants.Headers.Authorization, Constants.Headers.Bearer + accessToken.jarvis);
                }
                if (authenticationType & 128 && accessToken.pifd) {
                    request.set(Constants.Headers.Authorization, Constants.Headers.Bearer + accessToken.pifd);
                }
                if (authenticationType & 512 && accessToken.marketplaceLeads) {
                    request.set(Constants.Headers.Authorization, Constants.Headers.Bearer + accessToken.marketplaceLeads);
                }
                if (authenticationType & 1024 && accessToken.agreement) {
                    request.set(Constants.Headers.Authorization, Constants.Headers.Bearer + accessToken.agreement);
                }
            }
        };
        // the end request promise
        // it will perform the actual POST, PUT, GET or DEL
        const endRequest = ()=>{
            // sets the authentication headers depending on authentication type (if needed)
            setAuthenticationHeaders(this.option.authenticationType, HttpModule.getAccessToken(), this.option.setBearerHeader);
            return new Promise((resolve, reject)=>{
                setTimeout(()=>logOutRequestStart(request));
                if (self.option.requestCallback) {
                    self.option.requestCallback({
                        abort: ()=>{
                            return request.abort();
                        }
                    });
                }
                const start = Date.now();
                request.end((err, res)=>{
                    var _res_headers_contenttype, _res_headers_contenttype1;
                    const duration = Date.now() - start;
                    if (self.option.requestCallback) {
                        self.option.requestCallback(null);
                    }
                    if (err) {
                        const error = new HttpError(err);
                        setTimeout(()=>logOutRequestError(request, res, duration, error, false));
                        return reject(error);
                    }
                    const isJSON = (_res_headers_contenttype = res.headers['content-type']) === null || _res_headers_contenttype === void 0 ? void 0 : _res_headers_contenttype.includes('application/json');
                    const isRemoteChunk = ((_res_headers_contenttype1 = res.headers['content-type']) === null || _res_headers_contenttype1 === void 0 ? void 0 : _res_headers_contenttype1.includes('application/javascript')) && (this.endpoint.includes('agorasstatic') || this.endpoint.endsWith('remoteEntry.js'));
                    setTimeout(()=>logOutRequestEnd(request, res, duration));
                    if (self.option.returnRawResponse) {
                        resolve({
                            data: res,
                            headers: res.headers
                        });
                    } else if (res.ok && isJSON) {
                        resolve({
                            data: res.body,
                            headers: res.headers
                        });
                    } else if (isRemoteChunk) {
                        resolve({
                            data: res.body.toString('utf-8'),
                            headers: res.headers
                        });
                    } else {
                        resolve({
                            data: res.text,
                            headers: res.headers
                        });
                    }
                });
            });
        };
        if (shouldRefreshAccessToken) {
            // refresh access token will never fail
            // it is designed to always resolve even if the refresh itself fails
            const promise = fetchAccessTokens({
                resources: [
                    'spza',
                    'arm',
                    'graph',
                    'commerce',
                    'jarvis',
                    'marketplaceLeads',
                    'pifd',
                    'agreement'
                ]
            });
            return promise.then((accessToken)=>{
                var _HttpModule_getStore;
                // update the accesstoken in the state
                if (!accessToken) {
                    return Promise.reject(Constants.Telemetry.Action.RefreshToken);
                }
                const storedToken = mergeAccessToken({
                    currentAccessToken: HttpModule.getAccessToken(),
                    newAccessToken: accessToken
                });
                (_HttpModule_getStore = HttpModule.getStore()) === null || _HttpModule_getStore === void 0 ? void 0 : _HttpModule_getStore.dispatch(createSetAccessTokenAction(storedToken));
                HttpModule.updateAccessToken(storedToken);
                // endRequest returns a promise. So we need not catch exceptions from this then(..)
                return endRequest();
            });
        }
        return endRequest();
    }
    constructor(endpoint, method, option){
        _define_property(this, "endpoint", '');
        _define_property(this, "query", {});
        _define_property(this, "baseUrl", '');
        _define_property(this, "header", {});
        _define_property(this, "option", {});
        _define_property(this, "method", '');
        _define_property(this, "data", void 0);
        const appConfig = getAppConfig();
        // set default option
        this.addOption({
            clientType: appConfig.runtimeEnvironment,
            contentType: 'application/json',
            requireCorrelationId: true,
            flushTelemetry: false,
            retry: 2,
            stringifyPostData: false,
            parseResult: true,
            allowOrigin: false,
            fullEndpoint: false,
            returnRawResponse: false,
            authenticationType: 0,
            setBearerHeader: false,
            queryParams: {}
        });
        // merge custom option
        if (option) {
            this.addOption(option);
        }
        if (this.option.fullEndpoint) {
            this.baseUrl = appConfig.hostname;
            this.endpoint = `${this.baseUrl}${endpoint}`;
        } else {
            if (__SERVER__ && endpoint.startsWith('/')) {
                endpoint = `${appConfig.hostname}${endpoint}`;
            }
            this.endpoint = endpoint;
        }
        if (appConfig.XMSClientName) {
            this.header[Constants.Headers.XMSClientName] = appConfig.XMSClientName;
        }
        if (this.option.clientType !== 'browser') {
            this.header[Constants.Headers.UserAgent] = appConfig.httpUserAgent;
        }
        // set correlationId
        if (this.option.requireCorrelationId) {
            this.header[Constants.Headers.CorrelationId] = appConfig.correlationId;
        }
        this.header[Constants.Headers.ContentType] = this.option.contentType;
        this.header[Constants.Headers.RequestId] = this.option.requestId || generateGuid();
        this.initQuery(this.option.queryParams);
        this.method = method;
    }
}
export function post(endpoint, option) {
    return new HttpWrapper(endpoint, 'POST', option);
}
export function patch(endpoint, option) {
    return new HttpWrapper(endpoint, 'PATCH', option);
}
export function put(endpoint, option) {
    return new HttpWrapper(endpoint, 'PUT', option);
}
export function get(endpoint, option) {
    return new HttpWrapper(endpoint, 'GET', option);
}
export function del(endpoint, option) {
    return new HttpWrapper(endpoint, 'DELETE', option);
}
export const errorMessage = {
    'Failed to post': 'Failed to make a POST request',
    'Failed to get': 'Failed to make a GET request',
    'Failed to delete': 'Failed to make a DELETE request',
    'appId not availble': 'appId is not available to perform this operation',
    'correlationId not availble': 'correlationId is missing to perform this operation'
};
export var HttpModule;
